<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Preface">Preface</a></p>
<p class="toc1"><a href="#/Chapter1">1. A Daring Career Begins</a></p>
<p class="toc"><span href="#/Chapter2" title="Link target outside of Sample">2. Touring beyond the United States</span></p>
<p class="toc"><span href="#/Chapter3" title="Link target outside of Sample">3. Military Balloonist</span></p>
<p class="toc"><span href="#/Chapter4" title="Link target outside of Sample">4. Off to the Spanish-American War</span></p>
<p class="toc"><span href="#/Chapter5" title="Link target outside of Sample">5. Back to Denver</span></p>
<p class="toc"><span href="#/Chapter6" title="Link target outside of Sample">6. Airships and Airplanes</span></p>
<p class="toc"><span href="#/Chapter7" title="Link target outside of Sample">7. Eldorado Springs</span></p>
<p class="toc1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?3b4ee698